export const opcoesMulti = [
    { value: 1, label: 'Educação infantil - creche (0 a 3 anos)' },
    { value: 2, label: 'Educação infantil - pré-escola (4 e 5 anos)' },
    { value: 14, label: 'Ensino fundamental de 9 anos - 1º Ano' },
    { value: 15, label: 'Ensino fundamental de 9 anos - 2º Ano' },
    { value: 16, label: 'Ensino fundamental de 9 anos - 3º Ano' },
    { value: 17, label: 'Ensino fundamental de 9 anos - 4º Ano' },
    { value: 18, label: 'Ensino fundamental de 9 anos - 5º Ano' },
    { value: 19, label: 'Ensino fundamental de 9 anos - 6º Ano' },
    { value: 20, label: 'Ensino fundamental de 9 anos - 7º Ano' },
    { value: 21, label: 'Ensino fundamental de 9 anos - 8º Ano' },
    { value: 41, label: 'Ensino fundamental de 9 anos - 9º Ano' },
    { value: 25, label: 'Ensino médio - 1ª Série' },
    { value: 26, label: 'Ensino médio - 2ª Série' },
    { value: 27, label: 'Ensino médio - 3ª Série' },
    { value: 28, label: 'Ensino médio - 4ª Série' },
    { value: 29, label: 'Ensino médio - não seriada' },
    { value: 30, label: 'Curso técnico integrado (ensino médio integrado) 1ª Série' },
    { value: 31, label: 'Curso técnico integrado (ensino médio integrado) 2ª Série' },
    { value: 32, label: 'Curso técnico integrado (ensino médio integrado) 3ª Série' },
    { value: 33, label: 'Curso técnico integrado (ensino médio integrado) 4ª Série' },
    { value: 34, label: 'Curso técnico integrado (ensino médio integrado) não seriada' },
    { value: 74, label: 'Curso técnico integrado na modalidade EJA (EJA integrada à educação profissional de nível médio)' },
    { value: 35, label: 'Ensino médio - normal/magistério 1ª Série' },
    { value: 36, label: 'Ensino médio - normal/magistério 2ª Série' },
    { value: 37, label: 'Ensino médio - normal/magistério 3ª Série' },
    { value: 38, label: 'Ensino médio - normal/magistério 4ª Série' },
    { value: 39, label: 'Curso técnico - concomitante' },
    { value: 40, label: 'Curso técnico - subsequente' },
    { value: 69, label: 'EJA - ensino fundamental - anos iniciais' },
    { value: 70, label: 'EJA - ensino fundamental - anos finais' },
    { value: 71, label: 'EJA - ensino médio' },
    { value: 67, label: 'Curso FIC integrado na modalidade EJA - nível médio' },
    { value: 73, label: 'Curso FIC integrado na modalidade EJA – nível fundamental (EJA integrada à educação profissional de nível fundamental)' },
    { value: 68, label: 'Curso FIC concomitante' }
  ];